import { render } from "./StpCust.vue?vue&type=template&id=68655c5a"
import script from "./StpCust.vue?vue&type=script&lang=js"
export * from "./StpCust.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__